var map = {
	"./moto_fit_1.jpg": 87961,
	"./moto_fit_2.jpg": 5050,
	"./moto_fit_3.jpg": 47164,
	"./moto_fit_4.jpg": 48309,
	"./moto_fit_5.jpg": 69794
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6260;